/**
 * B2-RIDE - OpenAPI 3.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * Contact: mobile@pikyrent.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ScheduledBooking { 
    id: number;
    userId: number;
    cityId: number;
    hubId: number;
    modelId: number;
    startDateTime: Date;
    endDateTime: Date;
    referralCode?: string;
    status: ScheduledBooking.StatusEnum;
    createdAt: Date;
    deviceId?: number;
}
export namespace ScheduledBooking {
    export type StatusEnum = 'pending' | 'confirmed' | 'active' | 'completed' | 'cancelled' | 'expired';
    export const StatusEnum = {
        Pending: 'pending' as StatusEnum,
        Confirmed: 'confirmed' as StatusEnum,
        Active: 'active' as StatusEnum,
        Completed: 'completed' as StatusEnum,
        Cancelled: 'cancelled' as StatusEnum,
        Expired: 'expired' as StatusEnum
    };
}